<template>
  <sd-timeline
    ref="timeline"
    class-name="settings"
  />
</template>

<script>
import SdTimeline from '../../components/timeline';

export default {
  components: {
    SdTimeline,
  },
};
</script>
